import { render, staticRenderFns } from "./DialogOrg.vue?vue&type=template&id=92cd1080&scoped=true&"
import script from "./DialogOrg.vue?vue&type=script&lang=js&"
export * from "./DialogOrg.vue?vue&type=script&lang=js&"
import style0 from "./DialogOrg.vue?vue&type=style&index=0&id=92cd1080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cd1080",
  null
  
)

export default component.exports